"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FooterLarge;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _Skew = _interopRequireDefault(require("./Skew.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FooterLarge(_ref) {
  var title = _ref.title,
      description = _ref.description,
      links = _ref.links,
      socials = _ref.socials,
      copyright = _ref.copyright;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("footer", null, /*#__PURE__*/_react.default.createElement(_Skew.default, {
    color: "blueGray"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "relative bg-blueGray-100 pt-8 pb-6"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container mx-auto px-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap text-center lg:text-left"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full lg:w-6/12 px-4"
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "text-xl mt-4 font-bold"
  }, title), /*#__PURE__*/_react.default.createElement("h5", {
    className: "mt-1 mb-2 text-blueGray-500"
  }, description), /*#__PURE__*/_react.default.createElement("div", {
    className: "mt-6 lg:mb-0 mb-6"
  }, socials.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("a", {
      key: key,
      href: prop.link,
      target: "_blank",
      className: "bg-white text-" + prop.icon + "-regular shadow-lg font-normal h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none mr-2 inline-flex",
      type: "button"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "fab fa-" + prop.icon
    }));
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full lg:w-6/12 px-4"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap items-top mb-6"
  }, links.map(function (prop, key) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "w-full lg:w-4/12 px-4 ml-auto",
      key: key
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "block uppercase text-xs font-bold mb-2"
    }, prop.name), /*#__PURE__*/_react.default.createElement("ul", {
      className: "list-unstyled"
    }, (prop.items || []).map(function (itemProp, itemKey) {
      if (itemProp.to) {
        return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, _extends({}, itemProp, {
          key: itemKey,
          className: "text-blueGray-500 hover:text-blueGray-700 block pb-2 text-sm"
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("a", _extends({}, itemProp, {
          key: itemKey,
          className: "text-blueGray-500 hover:text-blueGray-700 block pb-2 text-sm"
        }));
      }
    })));
  })))), /*#__PURE__*/_react.default.createElement("hr", {
    className: "my-6 border-blueGray-200"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-wrap items-center md:justify-between justify-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full md:w-4/12 px-4 mx-auto text-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "text-sm text-blueGray-500 py-1"
  }, copyright)))))));
}

FooterLarge.defaultProps = {
  links: [],
  socials: []
};
FooterLarge.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  copyright: _propTypes.default.string,
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    name: _propTypes.default.string,
    // array of properties to pass to the link object
    // if you pass a prop named to, the link will be
    // generated using Link from react-router-dom
    items: _propTypes.default.arrayOf(_propTypes.default.object)
  })),
  socials: _propTypes.default.arrayOf( // this will generate an anchor with target blank to the given link
  _propTypes.default.shape({
    icon: _propTypes.default.oneOf(["facebook", "twitter", "instagram", "dribbble", "github"]),
    link: _propTypes.default.string
  }))
};
